<template>
  <div class="activate">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="userSubmit"
      v-if="step == '1'"
    >
      <div class="title">{{ $t.activate.title1 }}</div>
      <van-field :label="$t.activate.headImg">
        <template #input>
          <van-uploader v-model="headImg" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>
      <van-field
        v-model="form.UserName"
        :label="$t.activate.username"
        :name="$t.activate.username"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="form.Email"
        :label="$t.activate.email"
        :placeholder="$t.information.input"
      />
      <div class="tool-bar">
        <van-button round block type="info" native-type="submit">{{
          $t.activate.save
        }}</van-button>
      </div>
    </van-form>

    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="companySubmit"
      v-if="step == '2'"
    >
      <div class="title">{{ $t.activate.title2 }}</div>
      <van-field
        :label="$t.activate.companyLogoPic"
        :name="$t.activate.companyLogoPic"
        required
        :rules="formRule"
      >
        <template #input>
          <van-uploader
            v-model="companyLogoPic"
            :max-count="1"
            :after-read="afterRead2"
          />
        </template>
      </van-field>
      <van-field
        :label="$t.activate.businessLicence"
        :name="$t.activate.businessLicence"
        required
        :rules="formRule"
      >
        <template #input>
          <van-uploader
            v-model="businessLicence"
            :max-count="1"
            :after-read="afterRead3"
          />
        </template>
      </van-field>
      <van-field :label="$t.activate.officialSealPic">
        <template #input>
          <van-uploader
            v-model="officialSealPic"
            :max-count="1"
            :after-read="afterRead4"
          />
        </template>
      </van-field>
      <van-field
        v-model="cForm.CompanyName"
        :label="$t.activate.companyName"
        :name="$t.activate.companyName"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="cForm.CompanyProfileCn"
        :label="$t.activate.companyProfileCn"
        :placeholder="$t.information.input"
        type="textarea"
      />
      <van-field
        v-model="cForm.CompanyProfileEn"
        :label="$t.activate.companyProfileEn"
        :placeholder="$t.information.input"
        type="textarea"
      />
      <van-field
        v-model="cForm.LegalPersonName"
        :label="$t.activate.legalPersonName"
        :name="$t.activate.legalPersonName"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="cForm.CreditCode"
        :label="$t.activate.creditCode"
        :name="$t.activate.creditCode"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />
      <van-field
        v-model="cForm.DetailAddress"
        :label="$t.activate.detailAddress"
        :placeholder="$t.information.input"
        type="textarea"
      />
      <div class="tool-bar">
        <van-button round block type="info" native-type="submit">{{
          $t.activate.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { SET_AUTH } from "@/store/mutation-types";
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon } from "vant";

Vue.use(Form).use(Field).use(Button).use(Uploader).use(Icon);

export default {
  name: "activate",
  data() {
    return {
      step: "1",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      cForm: {},
      headImg: [],
      companyLogoPic: [],
      businessLicence: [],
      officialSealPic: [],
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    ...mapMutations([SET_AUTH]),
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getUserInfo() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
        };
        this.$api.myHome
          .getUserInfo(param)
          .then((res) => {
            this.form = res.data;
            this.SET_AUTH(res.data);
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    userSubmit() {
      this.$commonMethod.showLoading();
      this.$api.myHome
        .editUserInfo(this.form)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          if (this.form.CompanyCode) {
            this.pushHome();
          } else {
            this.step = "2";
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    companySubmit() {
      this.$commonMethod.showLoading();
      this.$api.myHome
        .addCompanyInfo(this.cForm)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.pushHome();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
    pushHome() {
      this.getUserInfo().then((success) => {
        if (success) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
            isParams: false,
            path: "home",
            name: "Home",
            query: [],
          });
        }
      });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.HeadImg = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.cForm.CompanyLogoPic = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead3(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.cForm.BusinessLicence = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead4(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.cForm.OfficialSealPic = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.activate {
  .avatarImg {
    width: 50px;
    height: 50px;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
